import { render, staticRenderFns } from "./minus.vue?vue&type=template&id=50af8daf&scoped=true"
import script from "./minus.vue?vue&type=script&lang=js"
export * from "./minus.vue?vue&type=script&lang=js"
import style0 from "./minus.vue?vue&type=style&index=0&id=50af8daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af8daf",
  null
  
)

export default component.exports